import React, { useCallback } from "react";
import { connect } from "react-redux";

import { faPencil } from "@fortawesome/pro-solid-svg-icons/faPencil";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Popover from "antd/es/popover";
import { useIntl } from "react-intl";

import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";
import Activity from "@mapmycustomers/shared/types/entity/Activity";
import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";

import RoundButton from "@app/component/RoundButton";
import ButtonType from "@app/enum/ButtonType";
import { activityListViewAnalytics } from "@app/scene/activity/activityTableAnalytics";
import { getActivityTypes } from "@app/store/activity";
import { RootState } from "@app/store/rootReducer";

import BulkEditPopoverContent from "./BulkEditPopoverContent";

interface Props {
  activityTypes: ActivityType[];
  className?: string;
  selected: Activity[];
}

const BulkEditButton: React.FC<Props> = ({ activityTypes, className, selected }) => {
  const [popoverVisible, showPopover, hidePopover, togglePopover] = useBoolean();
  const intl = useIntl();

  const handleVisibilityChange = useCallback(
    (visible) => {
      if (visible) {
        showPopover();
      } else {
        hidePopover();
      }
    },
    [showPopover, hidePopover]
  );

  const handleClick = useCallback(() => {
    activityListViewAnalytics.clicked(["Checkbox to Select All", "Edit"]);
    togglePopover();
  }, [togglePopover]);

  return (
    <Popover
      content={
        <BulkEditPopoverContent
          activityTypes={activityTypes}
          hidePopover={hidePopover}
          selected={selected}
        />
      }
      onVisibleChange={handleVisibilityChange}
      placement="bottomLeft"
      trigger={["click"]}
      visible={popoverVisible}
    >
      <RoundButton
        className={className}
        hasMenu
        leftIcon={<FontAwesomeIcon icon={faPencil} />}
        onClick={handleClick}
        type={ButtonType.SECONDARY}
      >
        {intl.formatMessage({
          id: "activity.listView.bulkEdit",
          defaultMessage: "Edit",
          description: "Label for bulk edit button",
        })}
      </RoundButton>
    </Popover>
  );
};

const mapStateToProps = (state: RootState) => ({
  activityTypes: getActivityTypes(state),
});

export default connect(mapStateToProps)(BulkEditButton);
